import React, { useState } from "react";
import HomeContent from "src/components/HomeContent";
import MainContent from "src/components/MainContent";

const Home: React.FC = () => {
  const [allTasksCompleted, setAllTasksCompleted] = useState(false);

  return (
    <>
      {allTasksCompleted ? (
        <HomeContent />
      ) : (
        <MainContent setAllTasksCompleted={setAllTasksCompleted} />
      )}
    </>
  );
};

export default Home;
